import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { isPublisher } from '~/helpers'
import { LinkInsertionOrder } from '~/modules/retailMedia/components/LinkInsertionOrder'

import { useCampaignForm } from '../../../hooks/useCampaignForm'

/**
 * Body of the objective-based Insertion Order step (PanelSteps provides chrome).
 */
export const LinkInsertionOrderStepContent = () => {
  const { t } = useTranslation()
  const {
    rmid,
    linkedInsertionOrder,
    setLinkedInsertionOrder,
    linkedInsertionOrderError,
    setLinkedInsertionOrderError
  } = useCampaignForm()

  const handleChange = useCallback(
    (insertionOrder: InsertionOrder | null) => {
      setLinkedInsertionOrder(insertionOrder)

      if (!insertionOrder) {
        setLinkedInsertionOrderError(null)
        return
      }

      if (!insertionOrder.checking_account_id) {
        setLinkedInsertionOrderError(
          t('rm:campaign.insertionOrder.missingCheckingAccount')
        )
        return
      }

      setLinkedInsertionOrderError(null)
    },
    [setLinkedInsertionOrder, setLinkedInsertionOrderError, t]
  )

  return (
    <div data-testid="objective-link-insertion-order-step">
      <LinkInsertionOrder
        value={linkedInsertionOrder}
        onChange={handleChange}
        advertiserId={isPublisher() ? rmid : undefined}
        required
        error={linkedInsertionOrderError || undefined}
      />
    </div>
  )
}
